<template>
  <transition name="fade" mode="out-in">
    <div class="fixed inset-0 bg-black/40 flex flex-col justify-center items-center h-screen z-50 w-full backdrop-blur-sm">
      <div class="flex flex-col w-full  justify-center items-center space-y-5">


        <div class="w-1/2 h-auto lg:w-40 lg:h-40 lg:aspect-auto aspect-square flex justify-center items-center">
          <Vue3Lottie :animationData="bottleAnimation" loop autoplay class="w-full h-full" />
        </div>

        <!-- i18n Title -->
        <p class="text-white text-lg font-semibold" :dir="direction">
          {{ t('scanBottle.loading') }}
        </p>

      </div>
    </div>
  </transition>
</template>

<script setup>
import { Vue3Lottie } from "vue3-lottie";
import { useI18n } from "vue-i18n";

// Import your Lottie JSON animation
import bottleAnimation from "@/assets/lottie/cokeBottleAnimationLottie.json";
import { computed } from "vue";

const { t, locale } = useI18n();

const direction = computed(() => (locale.value === 'fr' ? 'ltr' : 'rtl'));
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
